import { Table } from "components/ui/tables/Table/Table"
import { TeamTableColumns } from "./TeamTableColumns"
import type { IUsersTable } from "types/table.type"
import style from "./TeamTable.module.scss"

const { pageTeamTable } = style

export const TeamTable = ({ allUsers }: { allUsers: IUsersTable[] }) => {
	const tableData = allUsers?.map((item) => ({
		id: item.id,
		key: item.id,
		name: `${item.name} ${item.secondName}`,
		secondName: item.secondName,
		availableRoles: item.availableRoles,
		email: item.email,
		role: item.role,
		status: item.is_active,
		is_active: item.is_active,
	}))

	// Pass columns to table
	const columns = TeamTableColumns()

	return (
		<div className={pageTeamTable}>
			<Table<IUsersTable> data={tableData} columns={columns} />
		</div>
	)
}
